import React, { useContext, useEffect, useState } from 'react'
import { FormRow } from '../../../../../../_components/Forms/FormRow'
import { Box } from '../../../../../../components/Box/Box'
import { Grid, GridCol } from '../../../../../../components/Grid'
import { S_ScheduleEsigningContacts } from './DebtorsContacts.styles'
import { getScheduleDebtors } from '../../../../../../_services/lender.service'
import { RenderIf } from '../../../../../../components/helpers/RenderIf/RenderIf'
import ScheduleESigningContext from '../context'
import { StatusBanner } from '../../../../../../_components/StatusBanner'
import { LENDER_ROUTES } from '../../../../../../_constants/routes'
import { Link } from 'react-router-dom'

export const DebtorsContacts = ({ scheduleId, debtors }) => {
  const { addSigner, signers } = useContext(ScheduleESigningContext)
  const [debtorName, setDebtorName] = useState('')
  const [debtorContactsRoute, setDebtorContactsRoute] = useState('')

  useEffect(() => {
    getScheduleDebtors(scheduleId).then((debtors) => {
      setDebtorName(debtors[0].debtor_name)
      setDebtorContactsRoute(`${LENDER_ROUTES.debtor_details}/${debtors[0].id}/contacts`)
    })
  }, [scheduleId])

  if (!debtors.length) {
    return (
      <Box>
        <Grid columns={2}>
          <GridCol xs={1.5}>
            <div style={{ display: 'flex' }}>
              <div style={{ width: '130px', display: 'flex', alignItems: 'center' }}>
                <div>{debtorName}</div>
              </div>
              <StatusBanner
                className={`warning`}
                icon="warningtriangle"
                message={<Link to={debtorContactsRoute}>Add a debtor contact by clicking here.</Link>}
                style={{ width: 'auto' }}
              />
            </div>
          </GridCol>
        </Grid>
      </Box>
    )
  }

  const selectedOption = () => {
    const signer = Object.entries(signers).find(([_key, value]) => {
      return value.role === 'Debtor'
    })

    if (signer) {
      return signer[0]
    }

    return ''
  }

  const role = 'Debtor'
  return (
    <Box>
      <S_ScheduleEsigningContacts>
        <Grid columns={2}>
          <RenderIf condition={debtors && debtors.length > 0}>
            {[debtors[0]].map((debtor) => {
              //TODO debtors[0] - show only first debtor, temp solution for MVP
              const hasContacts = debtor?.contacts.length
              const key = `debtor_contact`
              return (
                <GridCol key={key} xs={1.5}>
                  <Box pb={'5px'} pt={'5px'}>
                    <FormRow
                      className={''}
                      defaultValue={selectedOption()}
                      disabled={!hasContacts}
                      id={key}
                      label={debtor.debtor_name}
                      layout={'inline'}
                      onChange={(id) => {
                        const contact = debtor.contacts.find((contact) => +contact.id === +id)
                        addSigner(contact.id, { ...contact, id: debtor.id }, role)
                      }}
                      options={debtor.contacts.map((contact) => {
                        return {
                          display: [contact.first_name, contact.last_name, `(${contact.email})`].join(' '),
                          value: contact.id,
                        }
                      })}
                      placeholder={hasContacts ? 'Select Contact' : 'No contacts to select'}
                      type={'select'}
                    />
                  </Box>
                </GridCol>
              )
            })}
          </RenderIf>
        </Grid>
      </S_ScheduleEsigningContacts>
    </Box>
  )
}
